"use strict";
const { getSettlementDates } = require('../agreements/properties');
module.exports = {
    getSettlementDates,
};
